<template>
    <div>
        <div class="button" v-if="phone">
            <p>如有疑问请联系当地分公司：<span>{{phone}}</span></p>
            <p>（10:00-12:00，14:00-18:00）</p>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    phone: String
  }
}
</script>
<style lang="scss" scoped>
.button{
    font-size: .24rem;
    color: #19191A;
    padding: .4rem .3rem;
    text-align: center;
    p span{
        color: #2A2AFF;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/appointed-road-test/components/BottomLayout.vue